import { api } from './api';
import { WorkflowStates } from '../../model/context/app/workflowStates';
import { LeadTabId } from '../../types/LeadsList';

const fetchWorkflowStates = async (token: string): Promise<WorkflowStates> => {
    let _url = api.workflowStates;

    const callOptions = {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    };

    const map = async (res: Response, type: LeadTabId) => ({ [type]: res.status === 200 ? await res.json() : [] });

    return await Promise.all([
        fetch(_url, callOptions).then((res) => (res.ok ? map(res, 'allLeads') : Promise.reject(res))),
        fetch(_url + '?statusType=MANUAL', callOptions).then((res) =>
            res.ok ? map(res, 'workflowTodos') : Promise.reject(res)
        ),
        fetch(_url + '?statusType=OPEN', callOptions).then((res) =>
            res.ok ? map(res, 'workflowOpen') : Promise.reject(res)
        ),
    ]).then((res) => {
        return res.reduce((base, load) => ({ ...base, ...load }), {}) as WorkflowStates;
    });
};

export default fetchWorkflowStates;
